// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1e01b116","239":"aaacb9e8","453":"1e85484b","455":"ae99363a"}[chunkId] + ".chunk.js";
};